import React from 'react';
import './RightArrow.css';

const RightArrow = (props) => {
    if(!props.visible) return null;

    return (
        <button className="b-button b-right-arrow" onClick={props.goToNextSlide}>
            <i className="fa fa-arrow-right fa-2x" aria-hidden="true"></i>
        </button>
    );
};

export default RightArrow;
